import React from 'react'
import {Award, Star, Crown, Shield} from 'lucide-react'

interface BadgeDisplayProps {
  tasksCompleted: number
  rating: number
  totalEarnings: number
}

export function BadgeDisplay({ tasksCompleted, rating, totalEarnings }: BadgeDisplayProps) {
  const getTier = () => {
    if (tasksCompleted >= 1000 && rating >= 4.8 && totalEarnings >= 50000) {
      return { name: 'Gold', color: 'from-yellow-400 to-yellow-600', icon: Crown, glow: 'shadow-yellow-500/50' }
    }
    if (tasksCompleted >= 500 && rating >= 4.5 && totalEarnings >= 20000) {
      return { name: 'Silver', color: 'from-slate-300 to-slate-500', icon: Shield, glow: 'shadow-slate-500/50' }
    }
    if (tasksCompleted >= 100 && rating >= 4.0 && totalEarnings >= 5000) {
      return { name: 'Bronze', color: 'from-orange-400 to-orange-600', icon: Award, glow: 'shadow-orange-500/50' }
    }
    return { name: 'Starter', color: 'from-slate-600 to-slate-800', icon: Star, glow: 'shadow-slate-500/30' }
  }

  const tier = getTier()
  const Icon = tier.icon

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r ${tier.color} rounded-full shadow-lg ${tier.glow}`}>
      <Icon className="w-4 h-4 text-white" />
      <span className="text-xs font-bold text-white">{tier.name}</span>
    </div>
  )
}

export function getBadgeTier(tasksCompleted: number, rating: number, totalEarnings: number) {
  if (tasksCompleted >= 1000 && rating >= 4.8 && totalEarnings >= 50000) {
    return 'Gold'
  }
  if (tasksCompleted >= 500 && rating >= 4.5 && totalEarnings >= 20000) {
    return 'Silver'
  }
  if (tasksCompleted >= 100 && rating >= 4.0 && totalEarnings >= 5000) {
    return 'Bronze'
  }
  return 'Starter'
}
